  import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  type: "success",
  open: false,
  msg: "",
  options: {},
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action) => {
      if (!action.payload) {
        return;
      }

      const { type, msg, message, options } = action.payload;

      state.type = type || "success";
      state.open = true;
      state.msg = msg || message || "";
      state.options = options || {};
    },
    closeToast: (state) => {
      state.open = false;
      state.msg = "";
      state.options = {};
    },
  },
});

export const { showToast, closeToast } = toastSlice.actions;
export default toastSlice.reducer;
